
import _com from "../../assets/js/common";
import jsonp from "../../assets/js/http";

import { Component, Vue } from "vue-property-decorator";

@Component
export default class insurance extends Vue {
	api={
        detail:"//sopc"+ this.domain +"/carInsAdmin/insure/find-product/detail.do",//shareAddress
        shareLiveMicroInsURL:"//api"+ this.domain +"/ylxditem/item/shareLiveMicroInsURL.do"
    }
    mounted() {
        if(sessionStorage.getItem("from")){
            sessionStorage.removeItem("from")
            this.toLink();
        }else
            history.go(-1);
    }
    toLink(){
        let subType =1;
        switch(this.$route.params.source){
            case "uxd":
                subType=1;    
            ;break;
            case "uzg":
                subType=6;    
            ;break;
        }
        jsonp(this.api.detail,{
            id: this.$route.params.id,
            jsonp: "jsonCallBack",
        }).then((data:any)=>{
            let shareType = 64;
            if(data.merchantId == 6)
                shareType = 63;
            let storeid:any = '';
            if(this.$route.query.storeid && this.$route.query.storeid !='undefined')
                storeid=this.$route.query.storeid;
            jsonp(this.api.shareLiveMicroInsURL,{
                shareLink:data.shareAddress,
                clientCallType:"H5",
                shareType: shareType,
                subType: subType,
                userId:storeid,
                jsonp: "jsoncallback",
            }).then((res:any)=>{
                window.location.href=res;
            });
        })
    }
    
}
